module.exports = __webpack_public_path__ + "img/9788981339517.35931c46.jpg";